import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { UserCredentials } from '../../types';
import { FormGroup, StyledLabel, inputStyle, ErrorMsg } from '../../constants/styles';
import { Button } from 'antd';

const propTypes = {};

const defaultProps = {};

type Props = {
  handleSubmit: (creds: { email: string, password: string }) => unknown,
  loggingIn: boolean
};

const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Correo inválido')
    .required('Este es un campo requerido'),
  password: Yup.string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .required('Este es un campo requerido'),
});

export default function LoginForm({
  handleSubmit = () => {},
  loggingIn = false,
}: Props) {
  return (
    <React.Fragment>
      <Formik
        initialValues=
        {{
          email: '',
          password: ''
        }}
        validationSchema={loginValidationSchema}
        onSubmit={values => {
          handleSubmit(values);
        }}
      >
        {
          () => (
            <Form>
              <FormGroup>
                <StyledLabel htmlFor="email">
                  Correo electrónico
                  </StyledLabel>
                <Field
                  id="email"
                  name="email"
                  type="email"
                  style={inputStyle}
                />
                <ErrorMessage name="email">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
              <FormGroup>
                <StyledLabel htmlFor="password">
                  Contraseña
                  </StyledLabel>
                <Field
                  id="password"
                  name="password"
                  type="password"
                  style={inputStyle}
                />
                <ErrorMessage name="password">
                  {errMsg => <ErrorMsg>{errMsg}</ErrorMsg>}
                </ErrorMessage>
              </FormGroup>
              <FormGroup>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={loggingIn}
                >
                  Iniciar sesión
                </Button>
              </FormGroup>

            </Form>
          )
        }
      </Formik>
    </React.Fragment>
  );
}

LoginForm.propTypes = propTypes;
LoginForm.defaultProps = defaultProps;